import api from '../utils/axiosCustomize';

const apiLogin = async (username, password) => {
    const response = await api.post('/auth/login', { email: username, password });
    return response.data;
};

const apiNvTeamDiemDanh = async (boPhan, ngay) => {
    const response = await api.post(`/chamcongs/`, { boPhan, ngay });
    return response.data;
};

const apiGetAllUser = async () => {
    const response = await api.get(`/users/user`);
    return response.data;
};

const apiGetJobHistory = async () => {
    const response = await api.get('/jobs/history');
    return response.data;
};

const apiSearchJobTheoNgayVaTeam = async (date, part) => {
    const response = await api.post(`/jobs/search`, { date, part });
    return response.data;
};

const apiGetMayTinhViecMoi = async () => {
    const response = await api.get(`/jobs/maytinh_viecmoi`);
    return response.data;
};
const apiGetCongTrinhViecMoi = async () => {
    const response = await api.get(`/jobs/congtrinh_viecmoi`);
    return response.data;
};

const apiGetDuAnViecMoi = async () => {
    const response = await api.get(`/jobs/duan`);
    return response.data;
};

const apiGetPhotocopyViecMoi = async () => {
    const response = await api.get(`/jobs/photo_viecmoi`);
    return response.data;
};

const apiPushNotiSuper = async (device_token, notificationType, customMessage) => {
    const response = await api.post(`/users/firebase_new`, { device_token, notificationType, customMessage });
    return response.data;
};

const apiDeleteJob = async (id) => {
    const response = await api.delete(`/jobs/${id}`);
    return response.data;
};

const apiUpdateStatusUser = async (id, status) => {
    const response = await api.put(`/users/change-user_status/${id}`, { status });
    return response.data;
};

const apiUpdateNoiDung = async (id, noi_dung) => {
    const response = await api.put(`/jobs/${id}`, { noi_dung });
    return response.data;
};

const apiGiaoJob = async (noi_dung, user_id) => {
    const response = await api.post(`/jobs/`, { noi_dung, user_id });
    return response.data;
};

export {
    apiLogin,
    apiNvTeamDiemDanh,
    apiGetAllUser,
    apiGetJobHistory,
    apiSearchJobTheoNgayVaTeam,
    apiGetMayTinhViecMoi,
    apiGetCongTrinhViecMoi,
    apiGetDuAnViecMoi,
    apiGetPhotocopyViecMoi,
    apiPushNotiSuper,
    apiDeleteJob,
    apiUpdateStatusUser,
    apiUpdateNoiDung,
    apiGiaoJob
};
